import LanguageList from '../../header-navigation/LanguageList'
import { LANDING_NAV } from '../useLandingNav'
import NavAuth from './NavAuth'
import NavLinks from './NavLinks'
import NavLogo from './NavLogo'
import NavStart from './NavStart'

const MainNavigation = () => {
  return (
    <header className={`${LANDING_NAV.HEIGHT} ${LANDING_NAV.Z_INDEX} px-32 py-8 w-full flex items-center 	bg-white/90`}>
      <nav className="w-full flex justify-between items-center">
        <div className="flex gap-x-24">
          <NavLogo />
          <ul className="flex gap-x-20 items-center">
            <NavLinks />
          </ul>
        </div>

        <ul className="flex gap-x-12 items-center">
          <LanguageList />
          <NavAuth />
          <NavStart />
        </ul>
      </nav>
    </header>
  )
}

export default MainNavigation
